// client/src/reservations/utils/timeGate.js
import { DateTime } from 'luxon';

export function isPastCutoffHHMM({ dayISO, hhmm, firstBookableISO, tz }) {
  if (!dayISO || !hhmm || !firstBookableISO || !tz) return false;
  const first = DateTime.fromISO(firstBookableISO).setZone(tz);
  const day = DateTime.fromISO(dayISO, { zone: tz });
  const slot = day.set({
    hour: Number(hhmm.slice(0,2)),
    minute: Number(hhmm.slice(3,5)),
    second: 0, millisecond: 0
  });
  return slot < first;
}
